import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@dm/core';
import { HeaderCommonTaskComponent } from './header-common-task.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
    ],
    declarations: [HeaderCommonTaskComponent],
    exports: [HeaderCommonTaskComponent],
})
export class HeaderCommonTaskModule { }
